import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/auth-context';

/**
 * Protege rotas que exigem login (ex.: /dashboard).
 * Enquanto a sessão salva é validada, mostra um estado de carregamento;
 * sem sessão válida, redireciona para /login.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <p className="page-loading">Carregando…</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
